// Select2 from npm
require('select2');
import Cookies from 'js-cookie';

// Set a cookie
// Cookies.set('cookie-name', 'cookie-value', { expires: 7 }); // expires in 7 days
//
// // Get a cookie
// const cookieValue = Cookies.get('cookie-name');
//
// // Remove a cookie
// Cookies.remove('cookie-name');

let selectedLocations = [],
    locationSelection = $('#location'),
    selectedLocationsContainer = $('.selected-locations');

locationSelection.select2({
    width: '100%'
});

locationSelection.on('change', function() {
    let selectedOption = $('#location [value="' + $(this).val() + '"]');

    // Check if already selected
    if(!selectedLocations.find(loc => loc.value === selectedOption.val())) {
        selectedLocations.push({ value: selectedOption.val(), text: selectedOption.text() });
        outputSelectedLocations();
    }
});

function outputSelectedLocations() {
    selectedLocationsContainer.empty();
    if(selectedLocations.length) {
        let newHiddenValue = '';

        selectedLocations.forEach(function(loc) {
            let locElem = $('<div class="selected-location-item"><span>' + loc.text + '</span><button class="remove-location" data-value="' + loc.value + '" aria-label="Remove ' + loc.text + '">' +
                '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<rect x="2.45312" y="0.83252" width="30" height="3" transform="rotate(45 2.45312 0.83252)" fill="#fff"/>' +
                '<rect x="0.332031" y="22.0459" width="30" height="3" transform="rotate(-45 0.332031 22.0459)" fill="#fff"/>' +
                '</svg></button></div>');
            selectedLocationsContainer.append(locElem);
            newHiddenValue += loc.value + ',';
        });
        // Add event listeners to remove buttons
        $('.remove-location').on('click', function() {
            let valueToRemove = $(this).data('value');
            selectedLocations = selectedLocations.filter(function(loc) {
                return loc.value !== valueToRemove;
            });
            outputSelectedLocations();
        });

        $('#states_hidden').val(newHiddenValue.slice(0, -1));
    }
}

$('#talent-community-form').on('submit', function(e) {
    e.preventDefault();
    console.log('form submit');
});


let talentCommunityPopupFormModal = $('#talent-community-popup-form-modal');

setTimeout(function() {
    if($('#show-tc-thank-you-popup').length) {
        talentCommunityPopupFormModal.modal('show');
    }

    if($('#show-tc-popup-with-errors').length) {
        talentCommunityPopupFormModal.modal('show');
    }
}, 1000);

if($('#tc-thank-you').length) {
    Cookies.set('talent-community-popup-shown', 'true', { expires: 7 }); // expires in 7 days
}

talentCommunityPopupFormModal.on('shown.bs.modal', function () {
    Cookies.set('talent-community-popup-shown', 'true', { expires: 7 }); // expires in 7 days
});

$(document).mouseleave(function () {
    if(Cookies.get('talent-community-popup-shown') !== 'true') {
        talentCommunityPopupFormModal.modal('show');
    }
});

$('#location-popup').select2({
    width: '100%'
});

$('#category-popup').select2({
    width: '100%'
});

$('#distance-popup').select2({
    width: '100%',
    // hide search
    minimumResultsForSearch: Infinity
});

$('#distance-form').select2({
    width: '100%',
    // hide search
    minimumResultsForSearch: Infinity
});

let selectedLocationsPopup = [],
    locationSelectionPopup = $('#location-popup'),
    selectedLocationsContainerPopup = $('.selected-locations-popup'),
    selectedCategoriesPopup = [],
    categorySelectionPopup = $('#category-popup'),
    selectedCategoriesContainerPopup = $('.selected-categories-popup');

locationSelectionPopup.on('change', function() {
    let selectedOption = $('#location-popup [value="' + $(this).val() + '"]');

    // Check if already selected
    if(!selectedLocationsPopup.find(loc => loc.value === selectedOption.val())) {
        selectedLocationsPopup.push({ value: selectedOption.val(), text: selectedOption.text() });
        outputSelectedLocationsPopup();
    }
});

function outputSelectedLocationsPopup() {
    selectedLocationsContainerPopup.empty();
    let newHiddenValuePopup = '';
    if(selectedLocationsPopup.length) {
        selectedLocationsPopup.forEach(function(loc) {
            let locElem = $('<div class="selected-location-item"><span>' + loc.text + '</span><button class="remove-location remove-location-popup" data-value="' + loc.value + '" aria-label="Remove ' + loc.text + '">' +
                '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<rect x="2.45312" y="0.83252" width="30" height="3" transform="rotate(45 2.45312 0.83252)" fill="#fff"/>' +
                '<rect x="0.332031" y="22.0459" width="30" height="3" transform="rotate(-45 0.332031 22.0459)" fill="#fff"/>' +
                '</svg></button></div>');
            selectedLocationsContainerPopup.append(locElem);
            newHiddenValuePopup += loc.value + ',';
        });
        // Add event listeners to remove buttons
        $('.remove-location-popup').on('click', function() {
            let valueToRemove = $(this).data('value');
            selectedLocationsPopup = selectedLocationsPopup.filter(function(loc) {
                return loc.value !== valueToRemove;
            });
            outputSelectedLocationsPopup();
        });
        $('#states_hidden_popup').val(newHiddenValuePopup.slice(0, -1));
    }
}

categorySelectionPopup.on('change', function() {
    let selectedOption = $('#category-popup [value="' + $(this).val() + '"]');

    // Check if already selected
    if(!selectedCategoriesPopup.find(cat => cat.value === selectedOption.val())) {
        selectedCategoriesPopup.push({ value: selectedOption.val(), text: selectedOption.text() });
        outputSelectedCategoriesPopup();
    }
});

function outputSelectedCategoriesPopup() {
    selectedCategoriesContainerPopup.empty();
    let newHiddenValuePopup = '';
    if(selectedCategoriesPopup.length) {
        selectedCategoriesPopup.forEach(function(cat) {
            let catElem = $('<div class="selected-category-item"><span>' + cat.text + '</span><button class="remove-category remove-category-popup" data-value="' + cat.value + '" aria-label="Remove ' + cat.text + '">' +
                '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<rect x="2.45312" y="0.83252" width="30" height="3" transform="rotate(45 2.45312 0.83252)" fill="#fff"/>' +
                '<rect x="0.332031" y="22.0459" width="30" height="3" transform="rotate(-45 0.332031 22.0459)" fill="#fff"/>' +
                '</svg></button></div>');
            selectedCategoriesContainerPopup.append(catElem);
            newHiddenValuePopup += cat.value + ',';
        });
        // Add event listeners to remove buttons
        $('.remove-category-popup').on('click', function() {
            let valueToRemove = $(this).data('value');
            selectedCategoriesPopup = selectedCategoriesPopup.filter(function(cat) {
                return cat.value !== valueToRemove;
            });
            outputSelectedCategoriesPopup();
        });
        $('#category_hidden_popup').val(newHiddenValuePopup.slice(0, -1));
    }
}

$('.close-talent-community-popup').on('click', function() {
    talentCommunityPopupFormModal.modal('hide');
});

// $("#talent-community-form").validate({
//     rules: {
//         first_name: "required",
//         last_name: "required",
//         email: {
//             required: true,
//             email: true
//         },
//         phone: "required",
//         'g-recaptcha-response': {
//             required: function() {
//                 return grecaptcha.getResponse() === '';
//             }
//         }
//     },
//     submitHandler: function(form) {
//         // some other code
//         // maybe disabling submit button
//         // then:
//         console.log('form valid, submitting');
//         // $(form).submit();
//         const recaptchaResponse = (typeof grecaptcha !== "undefined") ? grecaptcha.getResponse() : '';
//         console.log(recaptchaResponse.length);
//         if(recaptchaResponse.length === 0) {
//             alert('Please complete the reCAPTCHA');
//             return false;
//         }
//         form.submit();
//     }
// });
